"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.faBracketsSquare = void 0;
exports.faBracketsSquare = [
    448,
    512,
    [],
    "f7e9",
    "M120 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h88C133.3 480 144 469.3 144 456S133.3 432 120 432H48v-352h72C133.3 80 144 69.25 144 56S133.3 32 120 32zM416 32h-88C314.7 32 304 42.75 304 55.1S314.7 80 327.1 80H400v352h-72C314.7 432 304 442.7 304 455.1S314.7 480 327.1 480H416c17.6 0 32-14.4 32-32V64C448 46.4 433.6 32 416 32z",
];
